export default __webpack_public_path__ + "static/0g_desktop-4cde08f4d9eb0a0c2e7e8d961ae0395e.mp4";